<section class="verify-email">
  <div class="verify-email__card">
    @switch (state) {
      @case ('verifying') {
        <h2>Verifying…</h2>
        <p>One moment while we activate your contact email.</p>
      }
      @case ('success') {
        <h2>You’re all set</h2>
        <p>
          <strong>{{ contactEmail }}</strong> is now your FlowStudio contact email.
          Receipts and important alerts will be sent here.
        </p>
        <button type="button" class="verify-email__btn verify-email__btn--primary" (click)="continueToApp()">
          Continue to FlowStudio
        </button>
      }
      @case ('expired') {
        <h2>Link expired</h2>
        <p>This activation link has expired. Sign in to FlowStudio and request a new one.</p>
        <button type="button" class="verify-email__btn verify-email__btn--primary" (click)="continueToApp()">
          Go to FlowStudio
        </button>
      }
      @case ('superseded') {
        <h2>Newer link in use</h2>
        <p>
          A more recent activation request has replaced this one. Use the latest
          email we sent you, or request a new link from FlowStudio.
        </p>
        <button type="button" class="verify-email__btn verify-email__btn--primary" (click)="continueToApp()">
          Go to FlowStudio
        </button>
      }
      @case ('invalid') {
        <h2>Invalid link</h2>
        <p>
          This activation link is no longer valid. It may have already been used,
          or the URL was copied incorrectly.
        </p>
        <button type="button" class="verify-email__btn verify-email__btn--primary" (click)="continueToApp()">
          Go to FlowStudio
        </button>
      }
      @default {
        <h2>Something went wrong</h2>
        <p>We couldn’t verify the link right now. Try again in a moment.</p>
        <button type="button" class="verify-email__btn verify-email__btn--primary" (click)="continueToApp()">
          Go to FlowStudio
        </button>
      }
    }
  </div>
</section>
